import React from 'react'
import { connect } from 'react-redux'
import { Button, Breadcrumb, Modal } from 'semantic-ui-react'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'

import { contractPath } from 'routes'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import Information from '../Shareds/Information'
import CommentHistory from '../Shareds/CommentHistory'
import ConditionOfPayment from '../Shareds/ConditionOfPayment'
import PaymentCondition from '../Shareds/PaymentCondition'
import TimeOfContract from '../Shareds/TimeOfContract'
import TypeOfContract from '../Shareds/TypeOfContract'
import ContactPerson from '../Shareds/Contact'
import Attachment from '../Shareds/Attachment'
import { 
  MainBodyContent,
  StatusTag
} from 'components'
import {
  validateField,
  validateAttachments,
  validatePaymentConditions
} from '../helper'
import {
  getContractDetail,
  clearContractData,
  gethOptionContract,
  gethOptionTypeOfContract,
  gethPOCompleteDetail,
  updateContract,
  gethOptionAOPT,
  getContractWorkflowEditMode,
  deleteContract,
  approveActionContract
} from 'ducks/contract'
import { 
  showModal,
} from 'ducks/app'
import { 
  fetchRolePurchaseOfficer,
} from 'ducks/options'
import { 
  getHrmsMembers,
  getAllMembers
} from 'ducks/member'

import { 
  BottomActionsContainer,
  PCondition
} from './styled'
import r from 'reactotron-react-js'

const ContractEdit = (props) => {

  const { 
    history, 
    change,
    contractDetail, 
    valueForm,
    poCompleteDetail,
    poSelected,
    members,
    purchaseOfficer,
    isDetail = false,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [alertPCondition, setAlertPCondition] = React.useState(false)
  const [showDialogComment,setShowDialogComment] = React.useState(false)
  const [showAlertResubmit,setShowAlertResubmit] = React.useState(false)
  const [step,setStep] = React.useState(0)
  const firstLoad = step<3?true:false

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
    props.gethOptionContract()
    props.gethOptionAOPT()
    props.gethOptionTypeOfContract()
    if (match && match.params && match.params.contractId) {
      props.getContractDetail(match.params.contractId, history, true)
    }
    return (() => {
      props.clearContractData()
    })
  },[])

  React.useEffect(()=>{
    if(valueForm){
      props.getContractWorkflowEditMode({
        creater:valueForm.createdByUser,
        requester:valueForm.requesterUser,
        amount:poCompleteDetail.totalAmount,
        currency:poCompleteDetail.currencyCode,
        companyCode:poCompleteDetail.companyCode
      })
    }
  },[(valueForm&&valueForm.requesterUser),poCompleteDetail])

  React.useEffect(()=>{
    if(valueForm&&valueForm.poId){
      props.gethPOCompleteDetail(valueForm.poId)
    }else{
      change('projectName','')
      change('companyName','')
      change('vendorName','')
      change('totalAmount','')
      change('deductOfRetention','')
    }
  },[valueForm&&valueForm.poId])

  React.useEffect(()=>{
    if(poSelected&&poSelected.id){
      change('poSelectedNumber',`${poSelected.documentNumber} | ${poSelected.sapNumber} | ${poSelected.title}`)
      change('poId',poSelected.id)
      props.gethPOCompleteDetail(poSelected.id)
    }else{
      change('projectName','')
      change('companyName','')
      change('vendorName','')
      change('totalAmount','')
      change('deductOfRetention','')
      change('prRequester','')
      change('purchasing','')
    }
  },[poSelected])
  
  React.useEffect(()=>{
    if(Object.keys(poCompleteDetail).length){
      setStep(step+1)
      change('projectName',poCompleteDetail.projectName)
      change('companyName',`${poCompleteDetail.companyCode} | ${poCompleteDetail.companyName}`)
      change('vendorName',`${poCompleteDetail.vendorCode} | ${poCompleteDetail.vendorName}`)
      change('totalAmount',poCompleteDetail.totalAmount)
      change('deductOfRetention',firstLoad&&valueForm?valueForm.deductOfRetention:poCompleteDetail.deductOfRetention)
      change('prRequester',firstLoad&&valueForm?valueForm.prRequester:poCompleteDetail.prRequester)
      change('purchasing',firstLoad&&valueForm?valueForm.purchasing:poCompleteDetail.purchasing)
      change('purchGroup',poCompleteDetail.purchGroup)

      change('poSelectedNumber',`${poCompleteDetail.documentNumber} | ${poCompleteDetail.sapNumber} | ${poCompleteDetail.title}`)
      if(poSelected.id){
        change('poId',poSelected.id)
      }
    }else{
      change('projectName','')
      change('companyName','')
      change('vendorName','')
      change('totalAmount','')
      change('purchGroup','')
    }
  },[poCompleteDetail])

  React.useEffect(()=>{
    setStep(step+1)
    if(valueForm){
      let member = members.find(m => m.username === valueForm.prRequester)
      if (member) {
        change('prRequesterMobile',firstLoad?valueForm.prRequesterMobile:member.mobile1)
      } else if(valueForm.prRequesterMobile&&!firstLoad){
        change('prRequesterMobile','')
      }
    }
  },[valueForm&&valueForm.prRequester])
  
  React.useEffect(()=>{
    setStep(step+1)
    if(valueForm&&purchaseOfficer.data.length>0){
      let member = purchaseOfficer.data.find(m => m.username === valueForm.purchasing)
        if (member) {
        change('purchasingMobile',firstLoad?valueForm.purchasingMobile:member.mobile1)
      } else if(valueForm.purchasingMobile) {
        change('purchasingMobile','')
      }
    }
  },[valueForm&&valueForm.purchasing])

  React.useEffect(()=>{
    if(valueForm&&valueForm.purchGroup){
      props.fetchRolePurchaseOfficer(valueForm.purchGroup)
    }
  },[valueForm&&valueForm.purchGroup])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if(actionName=='delete'){
        props.deleteContract(valueForm.id,history)
      }else if(actionName=='cancel'){
        if((valueForm.actionComment&&valueForm.actionComment.trim().length === 0)||!valueForm.actionComment) {
          throw new SubmissionError({ actionComment: 'Required!'})
        }else{
          props.approveActionContract({
            docId: valueForm.id,
            sn: valueForm.sn,
            action: 'cancel',
            comment: valueForm.actionComment,
          }, history)
        }
      }else{
        let errors = validateField(valueForm, actionName)
        if(Object.keys(errors).length){
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        }else{
          if(actionName=='save'){
            props.updateContract(valueForm,history,false)
          }else{
            let missingAttachments = validateAttachments(valueForm)
            if(missingAttachments.length){
              props.showModal(
                true, 
                'Please attach document!',
                <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
              )
            }else{
              let validPaymentCondition = validatePaymentConditions(valueForm)
              if(!validPaymentCondition){
                setAlertPCondition(true)
                props.showModal(
                  true, 
                  'Systems',
                  'Please field Payment Condition!'
                )
              }else{
                if(actionName=='submit'||actionName=='resubmit'){
                  props.updateContract({...valueForm,forCheck:valueForm.requestContract=='C4'?false:poCompleteDetail.status!=4},history,true)
                }
              }
            }
          }
        }
      }
    })
  }

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{`Contract - ${contractDetail.documentNumber ? `Edit #${contractDetail.documentNumber}` : 'Edit'}`}<span style={{width:'1rem'}}/>{<StatusTag status={contractDetail.status||0} statusName={contractDetail.statusName||''}/>}</React.Fragment>}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={[
            { key: 'Contract', content: 'Contract', link: true, onClick: () => history.push(contractPath) },
            { key: 'Contract_Edit', content: 'Edit', active: true }
          ]}
        />
      }
    >
      <Information isEdit/>
      {Object.keys(contractDetail).length>0&&<TypeOfContract isEdit/>}
      <ConditionOfPayment isEdit/>
      <PCondition alert={alertPCondition}>
        <PaymentCondition isCreate/>
      </PCondition>
      <TimeOfContract isEdit/>
      <ContactPerson isEdit />
      <Attachment isEdit/>
      <br/>
      <CommentHistory/>

      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='submit'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>setActionName('save')}
          />
          {valueForm&&valueForm.status==0?
          <Button 
            type='submit'
            content={valueForm.requestContract=='C4'?'Save & Submit':poCompleteDetail.status==4?'Save & Submit':'Save and Check'} 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>setActionName('submit')}
          />:null}
          {valueForm&&valueForm.status==5?
          <Button 
            type='button'
            content='Save & Re-Submit'
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{
              if(poCompleteDetail.status==4){
                setShowDialogComment(true)
                setActionName('resubmit')
              }else{
                setShowAlertResubmit(true)
              }
            }}
          />:null}
          {valueForm&&valueForm.status==5&&valueForm.requestContract!='C4'?
          <Button 
            type='button'
            content='Cancel' 
            color='red' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('cancel')
            }}
          />:null}
          {valueForm&&valueForm.status==0&&valueForm.requestContract!='C4'?
          <Button 
            type='button'
            content='Delete' 
            color='red' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('delete')
            }}
          />:null}
        </BottomActionsContainer>
      </form>
      <Modal
        open={showAlertResubmit}
        header={<div className='header' style={{color:'#FE6F5F'}}>Alert!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={`Cannot save and submit this contract, Please wait for PO ${poCompleteDetail.sapNumber} completed.`}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertResubmit(false)}]}
      />
      {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName}/>}
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  let contractDetail = state.contract.contractDetail.data
  const date = new Date()
  return ({
    initialValues: {
      paymentConditions:[],
      contractLanguage:'Thai',
      documentDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      ...contractDetail
    },
    contractDetail,
    poSelected:state.contract.poSelected.data,
    poCompleteDetail:state.contract.poCompleteDetail.data,
    members: state.member.members,
    purchaseOfficer: state.options.purchaseOfficer,
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = {
  showModal,
  getContractDetail,
  clearContractData,
  gethOptionContract,
  gethOptionTypeOfContract,
  gethPOCompleteDetail,
  updateContract,
  gethOptionAOPT,
  getHrmsMembers,
  getContractWorkflowEditMode,
  deleteContract,
  approveActionContract,
  fetchRolePurchaseOfficer,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formContract',
  enableReinitialize: true,
})(ContractEdit)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)